<div class="wrap">
  <form *ngIf="!resetPasswordSent"
  [formGroup]="resetForm" (ngSubmit)="onSubmit()">
  <h2>Mot de passe oublié</h2>
  <div class="reset-field">
      <mat-form-field>
          <mat-label>Adresse mail</mat-label>
          <mat-icon matPrefix color="primary">person</mat-icon>
          <input type="text" matInput formControlName="email">
      </mat-form-field>
  </div>

  <button *ngIf="!isLoading"
      type="submit" mat-raised-button color="primary"
      [disabled]="resetForm.invalid || isLoading">Confirmer</button>
  <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary" ></mat-spinner>
</form>
<div *ngIf="resetPasswordSent">
  <p>{{'auth.changePassword.email' | translate}}</p>
</div>
</div>

